import apiV2 from '../../api/v2';

export interface TimelineEvent {
    id: string;
    type: string;
    visibility: 'internal' | 'shared';
    payload: Record<string, unknown>;
    createdAt: string;
    status: string;
}

interface ListTimelineEventsResponse {
    data: TimelineEvent[];
    total: number;
    page: number;
    limit: number;
}

/**
 * Returns the most recent timeline event of the given type, or null if none.
 *
 * Server-side filter `isLatest=true` + `limit=1` so the response is always
 * the single head row. The V2 envelope is unwrapped by the apiV2 interceptor.
 */
export async function fetchLatestEventByType(
    patientId: string,
    type: string
): Promise<TimelineEvent | null> {
    const response = await apiV2.get<ListTimelineEventsResponse>(
        `/patients/${encodeURIComponent(patientId)}/timeline`,
        { params: { type, isLatest: true, limit: 1 } }
    );
    const events = response.data?.data ?? [];
    return events[0] ?? null;
}

/**
 * Returns all timeline events of the given type for a patient.
 */
export async function fetchEventsByType(
    patientId: string,
    type: string,
    limit: number = 25
): Promise<TimelineEvent[]> {
    const response = await apiV2.get<ListTimelineEventsResponse>(
        `/patients/${encodeURIComponent(patientId)}/timeline`,
        { params: { type, limit } }
    );
    return response.data?.data ?? [];
}
